import React from 'react';
import styled from 'styled-components';
import { boxShadow, BoxShadowProps } from 'styled-system';

import { Box, BoxProps } from '~/components/Box';

export interface CardProps extends BoxProps {
  boxShadow: BoxShadowProps;
  rounded: boolean;
}

export const StyledCard = styled(Box)<CardProps>`
  background-color: white;
  ${boxShadow};
  border-radius: ${({ rounded }) => rounded && '4px'};
`;

export const Card = Object.assign(StyledCard, {
  defaultProps: {
    rounded: false,
    boxShadow: 2,
    p: 'xl',
  },
});

// TODO @grsmto: remove when https://github.com/pedronauck/docz/issues/337 is resolved
export const CardDocz = (props: CardProps) => {
  return <Card {...props} />;
};
try {
    // @ts-ignore
    StyledCard.displayName = "StyledCard";
    // @ts-ignore
    StyledCard.__docgenInfo = { "description": "", "displayName": "StyledCard", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Card/Card.tsx#StyledCard"] = { docgenInfo: StyledCard.__docgenInfo, name: "StyledCard", path: "src/components/Card/Card.tsx#StyledCard" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    Card.displayName = "Card";
    // @ts-ignore
    Card.__docgenInfo = { "description": "", "displayName": "Card", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Card/Card.tsx#Card"] = { docgenInfo: Card.__docgenInfo, name: "Card", path: "src/components/Card/Card.tsx#Card" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    CardDocz.displayName = "CardDocz";
    // @ts-ignore
    CardDocz.__docgenInfo = { "description": "", "displayName": "CardDocz", "props": { "boxShadow": { "defaultValue": null, "description": "", "name": "boxShadow", "required": true, "type": { "name": "BoxShadowProps" } }, "rounded": { "defaultValue": null, "description": "", "name": "rounded", "required": true, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Card/Card.tsx#CardDocz"] = { docgenInfo: CardDocz.__docgenInfo, name: "CardDocz", path: "src/components/Card/Card.tsx#CardDocz" };
}
catch (__react_docgen_typescript_loader_error) { }